import { auth } from '../firebase';
import { apiClient } from '../apiClient';

/**
 * Performs a complete user logout by revoking refresh tokens on the server
 * and signing out on the client.
 */
export const handleLogout = async () => {
  try {
    // Clear session storage flags (including OTP verification status)
    sessionStorage.removeItem('adminSessionVerified');
    sessionStorage.removeItem('loginTimestamp');

    // Attempt to call the backend endpoint to revoke refresh tokens on all devices
    await apiClient.post('/v1/auth/logout', {});
  } catch (error) {
    console.error('Error revoking refresh tokens during logout:', error);
  } finally {
    try {
      await auth.signOut();
    } catch (signOutError) {
      console.error('Error signing out from client SDK:', signOutError);
    }
  }
};
